import React, { useState } from "react";
import "./ProductImages.css";

const ProductImages = ({ images = [], mainImage = "" }) => {
  const [selectedImage, setSelectedImage] = useState(mainImage || (images.length > 0 ? images[0] : ""));

  // Mock data nếu không có images
  const mockImages = images.length > 0 ? images : [
    "https://via.placeholder.com/500x400/1e293b/4ade80?text=Product+Image+1",
    "https://via.placeholder.com/500x400/1e293b/4ade80?text=Product+Image+2", 
    "https://via.placeholder.com/500x400/1e293b/4ade80?text=Product+Image+3",
    "https://via.placeholder.com/500x400/1e293b/4ade80?text=Product+Image+4"
  ];

  return (
    <div className="product-images-container">
      {/* Main Image */}
      <div className="main-image-wrapper">
        <img 
          src={selectedImage} 
          alt="Product main" 
          className="main-image"
        />
        <div className="image-overlay">
          <button className="zoom-btn">
            🔍
          </button>
        </div>
      </div>

      {/* Thumbnail Images */}
      <div className="thumbnails-wrapper">
        {mockImages.map((image, index) => (
          <div 
            key={index}
            className={`thumbnail-item ${selectedImage === image ? 'active' : ''}`}
            onClick={() => setSelectedImage(image)}
          >
            <img 
              src={image} 
              alt={`Product ${index + 1}`}
              className="thumbnail-image"
            />
          </div>
        ))}
      </div>

      {/* Image Counter */}
      <div className="image-counter">
        <span>📷 {mockImages.length} ảnh</span>
      </div>
    </div>
  );
};

export default ProductImages;
